import script from "./SlideThumbnails.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideThumbnails.vue?vue&type=script&lang=ts&setup=true"

import "./SlideThumbnails.vue?vue&type=style&index=0&id=15912b32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15912b32"]])

export default __exports__